import React from 'react'
import { VerifiedTrustSealRecordEntity } from '../../interface/trust-seal.interface';
import { TRUST_SEAL_IMAGE_BASE } from '../../utils/constant'


interface ValidatedRecordProps {
    onOpenWhatsAppDialog: () => void;
    data: VerifiedTrustSealRecordEntity
}

const ValidatedRecord: React.FC<ValidatedRecordProps> = ({ onOpenWhatsAppDialog, data }) => (
    <section id="quotation" style={{ paddingBottom: '50px' }}>
        <div className="container">
            <div className="row mx-0">
                <div className="col-md-3" />
                <div className="col-md-6 text-center">
                    <div className="p-t-b-30">
                        <div className="p-b-30">
                            <img src={`${TRUST_SEAL_IMAGE_BASE}/valid.png`} alt="Valid" width="80" />
                        </div>
                        <h6 className="head6">Your Quotation is valid</h6>
                        <table className="tbl-bx">
                            <tbody>
                                <tr className="trows">
                                    <td>Order Number</td>
                                    <td>:</td>
                                    <td>{data.orderNumber}</td>
                                </tr>
                                <tr className="trows">
                                    <td>Version Number</td>
                                    <td>:</td>
                                    <td>{data.versionNumber}</td>
                                </tr>
                                <tr className="trows">
                                    <td>Date generated</td>
                                    <td>:</td>
                                    <td>{data.dateGenerated}</td>
                                </tr>
                                <tr className="trows">
                                    <td>Sales Representative</td>
                                    <td>:</td>
                                    <td>{data.salesRepresentative}</td>
                                </tr>
                                <tr className="trows">
                                    <td>Distributor Name</td>
                                    <td>:</td>
                                    <td>{data.distributorName}</td>
                                </tr>
                                <tr className="no-space order">
                                    <td>Project JURISDICTION</td>
                                    <td>:</td>
                                    <td>{data.cityName}, {data.stateName}</td>
                                </tr>
                                <tr className="no-space trows">
                                    <td />
                                    <td />
                                    <td style={{ textTransform: 'none', paddingBottom: '10px' }}>
                                        (This Estimate, material, installation and after-sales service is for project in {data.cityName} jurisdiction only)
                                    </td>
                                </tr>
                                <tr className="no-space order">
                                    <td>TOTAL SYSTEMS</td>
                                    <td>:</td>
                                    <td>{data.totalSystems}</td>
                                </tr>
                            </tbody>
                        </table>
                        <table className="tbl-bx" style={{ marginTop: '20px' }}>
                            <tbody>
                                <tr className="total">
                                    <td>Total AMOUNT</td>
                                    <td>:</td>
                                    <td style={{ textAlign: 'right' }}>₹ {Number(data.totalAmount).toLocaleString('en-IN')}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="p-b-30" style={{ marginBottom: '20px' }}>
                        <img src={`${TRUST_SEAL_IMAGE_BASE}/all-inclusive.png`} alt="All Inclusive" width="250" />
                    </div>
                    <h6 className="head6" style={{ marginBottom: '30px' }}>Cost Includes:</h6>
                    <ul className="lis-grid">
                        <li>
                            <img src={`${TRUST_SEAL_IMAGE_BASE}/gst.png`} alt="GST" width="60" />
                            <span>GST</span>
                        </li>
                        <li>
                            <img src={`${TRUST_SEAL_IMAGE_BASE}/insurance.png`} alt="Insurance" width="60" />
                            <span>
                                INSURANCE
                            </span>
                        </li>
                        <li>
                            <img src={`${TRUST_SEAL_IMAGE_BASE}/package.png`} alt="Package" width="60" />
                            <span>PACKAGING</span>
                        </li>
                        <li>
                            <img src={`${TRUST_SEAL_IMAGE_BASE}/freight.png`} alt="Freight" width="60" />
                            <span>FRIEGHT</span>
                        </li>
                        <li>
                            <img src={`${TRUST_SEAL_IMAGE_BASE}/installation.png`} alt="Installation" width="60" />
                            <span>INSTALLATION</span>
                        </li>
                    </ul>
                    <div style={{ marginTop: '60px' }}>
                        <button type='button' className="btn-brdr" onClick={onOpenWhatsAppDialog}>
                            SEND ME A PDF COPY
                        </button>
                    </div>
                </div>
                <div className="col-md-3" />
            </div>
        </div>
    </section>
)

export default ValidatedRecord
